import React, { useState, useEffect, useRef, useCallback, Fragment } from 'react'
import { connect } from 'react-redux';
import Box from '@mui/material/Box';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { sendSingleSms } from '../../../common/api';
import { toast } from 'react-toastify';
import Handlebars from 'handlebars/dist/cjs/handlebars';
// import 'emoji-mart/css/emoji-mart.css';
import Picker from '@emoji-mart/react';
import data from '@emoji-mart/data';
import InsertEmoticonIcon from '@mui/icons-material/InsertEmoticon';
import ScheduleButton from '../ScheduleButton';
import { useDropzone } from 'react-dropzone';
import { createFile } from '../../../common/api';
import { storeMedia, createId, render, getMimeTypeFromExtension } from '../../../common/utils';


const SendTxt = ( { user, accts, team, stack, viewing, contacts, loans, close, obj, objType, tmpl, defaultContact, extraFields } ) => {
    const [ from, setFrom ] = useState( '' );
    const [ senderList, setSenderList ] = useState( [] );
    const [ body, setBody ] = useState( '' );
    const [ attachments, setAttachments ] = useState( [] );
    const [ recipIdx, setRecipIdx ] = useState( -1 );
    const [ pList, setPList ] = useState( [] );
    const [ sending, setSending ] = useState( false );
    const [ noSender, setNoSender ] = useState( true );
    const [ noRecip, setNoRecip ] = useState( true );
    const [ tmplUsed, setTmplUsed ] = useState( '' );
    const [ showEmojis, setShowEmojis ] = useState( false );
    const [ allTmpls, setAllTmpls ] = useState( {} );
    
    
    const editorRef = useRef( null );

    const renderTemplate = useCallback( ( content ) => {
        if ( !content || !content.length ) {
            return '';
        }

        const a = accts.find( f => f.id === obj.aid );
        const owner = ( a ) ? team.find( f => f.email === a.owner ) : user;
        
        let params = {
            user: user,
            owner: owner,
            extra: extraFields
        };
        
        if ( objType === 'contact' ) {
            params['contact'] = {
                ...obj,
                referredBy: contacts[obj.referredById]
            };
        } else if ( objType === 'loan' ) {
            const pri = obj.borrowers.find( f => f.label === 'Primary' );
            const c = contacts[pri.cid];
            const lp2 = user.lists.team.find( f => f.uid === obj.lp2 );
            params['contact'] = {
                ...c,
                referredBy: contacts[c.referredById]
            };
            params['loan'] = {
                ...obj,
                buyersAgent: contacts[obj.baId],
                buyersAgentTC: contacts[obj.baTcId],
                listingAgent: contacts[obj.laId],
                listingAgentTC: contacts[obj.laTcId],
                escrow: contacts[obj.escrowOfficerId],
                title: contacts[obj.titleRepId],
                lp2rep: lp2
            };
        }

        console.log( 'params: ', params );
        return render( content, params, contacts );
    }, [ user, contacts, obj, objType, accts, team, extraFields ] );

    const addEmoji = ( e ) => {
        console.log( 'emoji: ', e );
        let emoji = e.native;
        setBody( prev => prev + emoji );
        setShowEmojis( false );
        if ( editorRef ) {
            editorRef.current.focus();
        }
    }

    const switchSender = ( from ) => {
        setFrom( from );
    };

    const onDrop = useCallback( acceptedFiles => {
        for ( let i = 0; i < acceptedFiles.length; i++ ) {
            const f = acceptedFiles[i];
            const reader = new FileReader();
            
            reader.onabort = () => {
                toast.success( `The upload process on ${f.path} has been aborted`, { theme: 'dark' } );
            }
            reader.onerror = () => {
                toast.success( `There's been an error while uploading ${f.path}`, { theme: 'dark' } );
            }
            reader.onload = async () => {
                const b = new Blob( [ reader.result ] );
                const ext = f.name.split( /(?:\.([^.]+))?$/ )[1];
                console.log( 'f: ', f );
                console.log( 'ext: ' + ext );
                let n = createId( 'file' );
                if ( ext ) {
                    n += '.' + ext;
                }
                console.log( 'n: ' + n );
                const name = await storeMedia( user.aid, user.email, n, b, getMimeTypeFromExtension( ext ) );
                
                let cid;
                let lid;

                if ( objType === 'contact' ) {
                    cid = obj.cid;
                } else if ( objType === 'loan' ) {
                    console.log( obj );
                    lid = obj.lid;
                    const c = obj.borrowers?.find( f => f.label === 'Primary' );
                    if ( c ) {
                        cid = c.cid;
                    }
                }

                let file = {
                    mediaUrl: name,
                    name: f.name
                }
                if ( cid ) {
                    file['cid'] = cid;
                }
                if ( lid ) {
                    file['lid'] = lid;
                }

                await createFile( user.aid, user.email, file );

                setAttachments( prev => [
                    ...prev,
                    { name: file.name, fid: file.mediaUrl }
                ] );
                // toast.success( `Successfully uploaded ${f.name}`, { theme: 'dark' } );
                console.log( 'uploaded: ', name );
            }
            reader.readAsArrayBuffer( f );
        }
    }, [ user.aid, user.email, obj, objType ] );

    const { getRootProps, getInputProps, isDragActive } = useDropzone( { onDrop } );

    const removeAttachment = ( file ) => {
        setAttachments( prev => {
            const list = prev.filter( f => f.name !== file );
            return [ ...list ];
        } );
    }

    const send = async ( d, t, tz ) => {
        setSending( true );

        const msg = {
            to: pList[recipIdx],
            body: body,
            tmpl: tmplUsed,
            attachments: attachments,
            date: d,
            time: t,
            tz: tz,
            channel: 'sms'
        };

        if ( from && from.length ) {
            msg['from'] = from;
        }
        
        if ( objType === 'loan' ) {
            msg['lid'] = obj.lid;
            const c = obj.borrowers?.find( f => f.label === 'Primary' );
            if ( c ) {
                msg['contactId'] = c.cid;
            }
        } else if ( objType === 'contact' ) {
            msg['contactId'] = obj.cid;
        } else if ( objType === 'task' ) {
            if ( obj.assoc ) {
                const ta = obj.assoc[0];
                if ( ta.lid ) {
                    msg['lid'] = ta.lid;
                } 
                if ( ta.cid ) {
                    msg['contactId'] = ta.cid;
                }
            }
        } else {
            console.log( 'unknown objType: ' + objType );
        }

        console.log( 'msg: ', msg );
        
        const s = senderList.find( f => f.number === from );
        const sent = await sendSingleSms( ( obj.shared && s ) ? s.aid : obj.aid, user.email, msg );
        // if ( sent.length ) {
            setSending( false );
            toast.success( `The Text has been Sent`, { theme: 'dark' } );
            close();
        // }
        console.log( sent );
        setSending( false );
    };

    useEffect( () => {
        if ( from && from.length ) {
            setNoSender( false );
        } else {
            setNoSender( true );
        }
    }, [ from ] );

    useEffect( () => {
        if ( recipIdx > -1 && pList[recipIdx] && pList[recipIdx].phone ) {
            setNoRecip( false );
        } else {
            setNoRecip( true );
        }
    }, [ recipIdx, pList ] );

    useEffect( () => {
        if ( tmpl ) {
            if ( allTmpls && Object.keys( allTmpls ).length ) {
                Object.keys( allTmpls ).forEach( tid => {
                    if ( tid === tmpl ) {
                        const t = allTmpls[tid];
                        setTmplUsed( t.tid );
                    }
                } );
            }
        }
    }, [ tmpl, allTmpls ] );

    useEffect( () => {
        if ( tmplUsed && allTmpls[tmplUsed] ) {
            const t = allTmpls[tmplUsed];
            console.log( 'Using template: ', t );
            setBody( renderTemplate( t.body ) );
        } else {
            // setBody( '' );
        }
    }, [ tmplUsed, allTmpls, renderTemplate ] );

    useEffect( () => {
        let list = [];
        const seen = new Set();
        let c;
        let l;

        switch ( objType ) {
            case 'contact':
                c = obj;
                break;

            case 'loan':
                l = obj;
                break;

            case 'task':
                if ( obj.assoc ) {
                    const ta = obj.assoc[0];
                    if ( ta.lid ) {
                        console.log( 'Using task loan: ', ta.lid );
                        l = loans[ta.lid];
                    } else {
                        console.log( 'Using task contact: ', ta.cid );
                        c = contacts[ta.cid];
                    }
                } else {
                    console.log( 'No task associations: ', obj );
                }
                break;

            default:
                console.log( 'Unhandled objType: ', objType );
        }

        if ( c ) {
            let mainContactHasPhone = false;

            // contact
            if ( c.phoneMobile ) {
                mainContactHasPhone = true;

                list.push( {
                    label: `${c.name} - Mobile - ${c.phoneMobile}`,
                    cid: c.cid,
                    phone: c.phoneMobile,
                    defaultContact: 'contact'
                } );
                seen.add( c.phoneMobile );
            }
            if ( c.phone ) {
                mainContactHasPhone = true;

                if ( !seen.has( c.phone ) ) {
                    list.push( {
                        label: `${c.name} - Phone - ${c.phone}`,
                        cid: c.cid,
                        phone: c.phone,
                        defaultContact: 'contact'
                    } );
                    seen.add( c.phone );
                }
            }
            if ( c.phoneHome ) {
                mainContactHasPhone = true;

                if ( !seen.has( c.phoneHome ) ) {
                    list.push( {
                        label: `${c.name} - Home - ${c.phoneHome}`,
                        cid: c.cid,
                        phone: c.phoneHome,
                        defaultContact: 'contact'
                    } );
                    seen.add( c.phoneHome );
                }
            }
            if ( c.phoneWork ) {
                mainContactHasPhone = true;

                if ( !seen.has( c.phoneWork ) ) {
                    list.push( {
                        label: `${c.name} - Work - ${c.phoneWork}`,
                        cid: c.cid,
                        phone: c.phoneWork,
                        defaultContact: 'contact'
                    } );
                    seen.add( c.phoneWork );
                }
            }

            if ( !mainContactHasPhone ) {
                list.push( {
                    label: `${c.name} - No Phone!`,
                    cid: c.cid,
                    defaultContact: 'contact'
                } );
            }

            if ( c.phonePartner1 ) {
                if ( !seen.has( c.phonePartner1 ) ) {
                    const name = ( c.firstnamePartner1 ) ? `${c.firstnamePartner1} ${c.lastnamePartner1}` : c.namePartner1;
                    list.push( {
                        label: `Partner 1: ${name} - ${c.phonePartner1}`,
                        cid: c.cid,
                        phone: c.phonePartner1,
                        defaultContact: 'partner1'
                    } );
                    seen.add( c.phonePartner1 );
                }
            }
            if ( c.phonePartner2 ) {
                if ( !seen.has( c.phonePartner2 ) ) {
                    const name = ( c.firstnamePartner2 ) ? `${c.firstnamePartner2} ${c.lastnamePartner2}` : c.namePartner2;
                    list.push( {
                        label: `Partner 2: ${name} - ${c.phonePartner2}`,
                        cid: c.cid,
                        phone: c.phonePartner2,
                        defaultContact: 'partner2'
                    } );
                    seen.add( c.phonePartner2 );
                }
            }
            if ( c.referredById ) {
                const ref = contacts[c.referredById];
                if ( ref ) {
                    if ( !seen.has( ref.phoneMobile ) ) {
                        if ( ref.phoneMobile ) {
                            list.push( {
                                label: `Referred By: ${ref.name} - Mobile - ${ref.phoneMobile}`,
                                cid: ref.cid,
                                phone: ref.phoneMobile,
                                defaultContact: 'referredBy'
                            } );
                        }
                        seen.add( ref.phoneMobile );
                    }
                    if ( !seen.has( ref.phone ) ) {
                        if ( ref.phone ) {
                            list.push( {
                                label: `Referred By: ${ref.name} - Phone - ${ref.phone}`,
                                cid: ref.cid,
                                phone: ref.phone,
                                defaultContact: 'referredBy'
                            } );
                        }
                        seen.add( ref.phone );
                    }
                }
            }
        } else if ( l ) {
            // loan
            const borrowers = l.borrowers || [];
            const ba = contacts[l.baId];
            const la = contacts[l.laId];
            let r;
            
            borrowers.sort( ( a, b ) => {
                if ( a.label === 'Primary' ) {
                    return -1;
                } else if ( b.label === 'Primary' ) {
                    return 1;
                } else {
                    return 0;
                }
            } );

            for ( const b of borrowers) {
                const c = contacts[b.cid];
                const label = ( b.label === 'Primary' ) ? 'Pri' : 'CoBo';

                if ( c.phoneMobile ) {
                    list.push( {
                        label: `${label}: ${c.name} - Mobile - ${c.phoneMobile}`,
                        cid: c.cid,
                        phone: c.phoneMobile,
                        defaultContact: 'contact'
                    } );
                    seen.add( c.phoneMobile );
                }
                if ( c.phone ) {
                    if ( !seen.has( c.phone ) ) {
                        list.push( {
                            label: `${label}: ${c.name} - Phone - ${c.phone}`,
                            cid: c.cid,
                            phone: c.phone,
                            defaultContact: 'contact'
                        } );
                        seen.add( c.phone );
                    }
                }
                if ( c.phoneHome ) {
                    if ( !seen.has( c.phoneHome ) ) {
                        list.push( {
                            label: `${label}: ${c.name} - Home - ${c.phoneHome}`,
                            cid: c.cid,
                            phone: c.phoneHome,
                            defaultContact: 'contact'
                        } );
                        seen.add( c.phoneHome );
                    }
                }
                if ( c.phoneWork ) {
                    if ( !seen.has( c.phoneWork ) ) {
                        list.push( {
                            label: `${label}: ${c.name} - Work - ${c.phoneWork}`,
                            cid: c.cid,
                            phone: c.phoneWork,
                            defaultContact: 'contact'
                        } );
                        seen.add( c.phoneWork );
                    }
                }
                if ( c.phonePartner1 ) {
                    if ( !seen.has( c.phonePartner1 ) ) {
                        const name = ( c.firstnamePartner1 ) ? `${c.firstnamePartner1} ${c.lastnamePartner1}` : c.namePartner1;
                        list.push( {
                            label: `Partner 1: ${name} - ${c.phonePartner1}`,
                            cid: c.cid,
                            phone: c.phonePartner1,
                            defaultContact: 'partner1'
                        } );
                        seen.add( c.phonePartner1 );
                    }
                }
                if ( c.phonePartner2 ) {
                    if ( !seen.has( c.phonePartner2 ) ) {
                        const name = ( c.firstnamePartner2 ) ? `${c.firstnamePartner2} ${c.lastnamePartner2}` : c.namePartner2;
                        list.push( {
                            label: `Partner 2: ${name} - ${c.phonePartner2}`,
                            cid: c.cid,
                            phone: c.phonePartner2,
                            defaultContact: 'partner2'
                        } );
                        seen.add( c.phonePartner2 );
                    }
                }
                if ( b.label === 'Primary' && c.referredById ) {
                    r = contacts[c.referredById];
                }
            }
            
            if ( ba ) {
                if ( ba.phoneMobile ) {
                    list.push( {
                        label: `Buyer Agent: ${ba.name} - Mobile - ${ba.phoneMobile}`,
                        cid: ba.cid,
                        phone: ba.phoneMobile,
                        defaultContact: 'ba'
                    } );
                    seen.add( ba.phoneMobile );
                }
                if ( ba.phone ) {
                    if ( !seen.has( ba.phone ) ) {
                        list.push( {
                            label: `Buyer Agent: ${ba.name} - Phone - ${ba.phone}`,
                            cid: ba.cid,
                            phone: ba.phone,
                            defaultContact: 'ba'
                        } );
                        seen.add( ba.phone );
                    }
                }
            }
            if ( la ) {
                if ( la.phoneMobile ) {
                    list.push( {
                        label: `List Agent: ${la.name} - Mobile - ${la.phoneMobile}`,
                        cid: la.cid,
                        phone: la.phoneMobile,
                        defaultContact: 'la'
                    } );
                    seen.add( la.phoneMobile );
                }
                if ( la.phone ) {
                    if ( !seen.has( la.phone ) ) {
                        list.push( {
                            label: `List Agent: ${la.name} - Phone - ${la.phone}`,
                            cid: la.cid,
                            phone: la.phone,
                            defaultContact: 'la'
                        } );
                        seen.add( la.phone );
                    }
                }
            }
            if ( r ) {
                if ( r.phoneMobile ) {
                    list.push( {
                        label: `Ref Source: ${r.name} - Mobile - ${r.phoneMobile}`,
                        cid: r.cid,
                        phone: r.phoneMobile,
                        defaultContact: 'ref'
                    } );
                    seen.add( r.phoneMobile );
                }
                if ( r.phone ) {
                    if ( !seen.has( r.phone ) ) {
                        list.push( {
                            label: `Ref Source: ${r.name} - Phone - ${r.phone}`,
                            cid: r.cid,
                            phone: r.phone,
                            defaultContact: 'ref'
                        } );
                        seen.add( r.phone );
                    }
                }
            }
            
        }
        
        if ( recipIdx === -1 ) {
            if ( defaultContact ) {
                const idx = list.findIndex( f => f.defaultContact === defaultContact );
                if ( idx > -1 ) {
                    setRecipIdx( idx );
                } else {
                    setRecipIdx( 0 );
                }
            } else {
                setRecipIdx( 0 );
            }
        }

        setPList( list );
    }, [ objType, obj, contacts, loans, defaultContact, recipIdx ] );
    
    useEffect( () => {
        let temps = {};

        const a = accts.find( f => f.id === obj.aid );
        if ( a && a.crm && a.crm.meta && a.crm.meta.templates && a.crm.meta.templates.length ) {
            a.crm.meta.templates.forEach( t => {
                if ( t.channel !== 'sms' ) {
                    return;
                }
                if ( !t.objects || t.objects.includes( objType ) ) {
                    temps[t.tid] = t;
                }
            } );
        }
        if ( user.templates && user.templates.length ) {
            user.templates.forEach( t => {
                if ( t.channel !== 'sms' ) {
                    return;
                }
                if ( !t.objects || t.objects.includes( objType ) ) {
                    temps[t.tid] = t;
                }
            } );
        }

        setAllTmpls( temps );
    }, [ user.templates, user.meta.templates, objType, accts, obj.aid ] );

    useEffect( () => {
        let list = [];
        console.log( 'obj : ', obj );
        if ( obj && user.additionalAccounts ) {
            console.log( 'has additional accounts: ', user.additionalAccounts)
            if ( viewing.length === 1 ) {
                const a = user.additionalAccounts.find( f => f.aid === viewing[0] );
                if ( a ) {
                    console.log( 'pushing a: ', a );
                    if ( typeof( a.sms ) === 'string' ) {
                        list.push( { label: a.aid, number: a.sms, aid: a.aid } );
                    } else {
                        for ( const s of a.sms ) {
                            list.push( { label: s.label, number: s.number, aid: a.aid } );
                        }
                    }
                }
            } else {
                if ( !obj.shared ) {
                    const a = user.additionalAccounts.find( f => f.aid === obj.aid );
                    if ( a ) {
                        if ( typeof( a.sms ) === 'string' ) {
                            list.push( { label: a.aid, number: a.sms, aid: a.aid } );
                        } else {
                            for ( const s of a.sms ) {
                                list.push( { label: `${a.aid} - ${s.label}`, number: s.number, aid: a.aid } );
                            }
                        }
                    }
                } else {
                    for ( let i = 0; i < viewing.length; i++ ) {
                        const a = user.additionalAccounts.find( f => f.aid === viewing[i] );
                        if ( a ) {
                            if ( typeof( a.sms ) === 'string' ) {
                                list.push( { label: a.aid, number: a.sms, aid: a.aid } );
                            } else {
                                for ( const s of a.sms ) {
                                    list.push( { label: `${a.aid} - ${s.label}`, number: s.number, aid: a.aid } );
                                }
                            }
                        }
                    }
                }
            }
        } else if ( stack.sms && stack.sms.phones && stack.sms.phones.length ) {
            console.log( 'stack.sms.phones: ', stack.sms.phones, user );
            stack.sms.phones.forEach( p => list.push( { label: p.label, number: p.number, aid: user.aid } ) );
        } else if ( stack.sms && stack.sms.phone ) {
            console.log( 'single phone: ', stack.sms.phone );
            list.push( { label: user.aid, number: stack.sms.phone, aid: user.aid } );
        }

        console.log( 'sender list: ', list );
        setSenderList( list );
        if ( list.length === 1 ) {
            setFrom( list[0].number );
        }
    }, [ user, stack.sms, obj, viewing ] );

    // useEffect( () => {
    //     console.log( 'allTmpls: ', allTmpls );
    //     Object.entries( allTmpls ).map( ( t, idx ) => console.log( idx, t ) )
    // }, [ allTmpls ] );

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '750px',
        bgcolor: 'background.paper',
        border: '1px solid #000',
        p: 2,
        maxHeight: '95vh',
        overflowY: 'auto'
    };
    
    return (
        <Fragment>
            <Box sx={ { ...style, pt: 0 } }>
                <Row className='py-2' style={ { borderBottom: '1px solid var( --bs-border-color )' } }>
                    <Col className='tf-modal-title'>Send a Txt</Col>
                </Row>
                <Row className='pt-3'>
                    <Col>
                    <Form.Group as={Row} className='tf-form-group align-items-center px-3 pb-3 tf-email-header-row'>
                        <Form.Label column xs='auto' className='col-md-auto p-0 fw-light'>To</Form.Label>
                        <Col xs='auto' className='tf-form-select-field me-1'>
                            <Form.Select size='sm' className='tf-modal-select-input' value={recipIdx} onChange={ ( e ) => setRecipIdx( e.target.value ) }>
                                {/* <option value={-1}>Choose Recipient</option> */}
                                {
                                    pList.map( ( p, idx ) => <option key={idx} value={idx}>{p.label}</option>)
                                }
                            </Form.Select>
                        </Col>
                    </Form.Group>
                    </Col>
                </Row>
                <Row className='pt-3'>
                    <Col>
                        <Form.Group as={Row} className='tf-form-group align-items-center px-3 pb-3 tf-email-header-row'>
                            <Form.Label column xs='auto' className='col-md-auto p-0 fw-light'>From</Form.Label>
                            {
                                ( senderList.length === 1 ) ? (
                                    <Col className='tf-email-header-value'>{from}</Col>
                                ) : (
                                    <Col xs='auto' className='tf-email-header-value tf-form-select-field me-1'>
                                        <Form.Select size='sm' className='tf-modal-select-input' value={from} onChange={ ( e ) => switchSender( e.target.value ) }>
                                            <option value=''>Choose a Sender</option>
                                            {
                                                senderList.map( ( s, idx ) => <option key={`sender-${idx}`} value={s.number}>{s.label} - {s.number}</option> )
                                            }
                                        </Form.Select>
                                    </Col>
                                )
                            }
                        </Form.Group>
                    </Col>
                </Row>
                <Row className='pt-3'>
                    <Col>
                        <Row className='tf-sms-editor-header align-items-center'>
                            <Col xs='auto'>
                                <Button onClick={ () => setShowEmojis( prev => !prev ) } variant='link'><InsertEmoticonIcon /></Button>
                                { showEmojis ? <Picker data={data} onEmojiSelect={ addEmoji } /> : null }
                            </Col>
                            <Col xs='auto'>
                                <Form.Select size='sm' className='tf-modal-select-input' value={tmplUsed} onChange={ ( e ) => setTmplUsed( e.target.value ) }>
                                    <option value=''>Load a Template</option>
                                    {
                                        Object.entries( allTmpls ).map( ( [ tid, t ] ) => <option key={`tmpl-${tid}`} value={t.tid}>{t.name}</option> )
                                    }
                                </Form.Select>
                            </Col>
                        </Row>
                        <Row className='tf-sms-editor-body'>
                            <Col className='py-2'>
                                <textarea className='tf-sms-editor-ta' 
                                    ref={ editorRef }
                                    value={ body } 
                                    onChange={ ( e ) => setBody( e.target.value ) } 
                                    placeholder="Type your message here..."
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
                {
                    attachments.length ? (
                        <Container fluid className='pe-0'>
                            <Row className='w-100 py-2 me-0'>
                                { attachments.map( a => <Col key={a.name} xs='auto'><span className='tf-email-attachment-file'>{a.name}</span><span className='tf-email-attachment-delete' onClick={ () => removeAttachment( a.name ) }>X</span></Col>) }
                            </Row>
                        </Container>
                    ) : (
                        null
                    )
                }
                <Container fluid className='pe-0'>
                    <Row className='w-100 py-2 me-0 align-items-center'>
                        <Col className='p-2 text-center' { ...getRootProps() } style={ { color: 'var( --tf-blue )', fontWeight: 600, border: '1px dotted var( --tf-blue )' } }>
                            <input { ...getInputProps() } />
                            <Row><Col>Drop Attachments or <Button variant='outline-primary' size='sm'>Select Files</Button></Col></Row>
                        </Col>
                    </Row>
                </Container>
                <Container fluid>
                    <Row className='w-100 p-2 align-items-center'>
                        <Col className='pe-2 text-end'><ScheduleButton send={send} disabled={sending || noSender || noRecip} /></Col>
                        <Col className='ps-2 text-start'><Button variant='outline-dark' onClick={close}>Cancel</Button></Col>
                    </Row>
                </Container>
            </Box>
        </Fragment>
    )
}

const mapProps = ( state ) => ( {
    user: state.user,
    accts: state.user.lists.accounts,
    team: state.user.lists.team,
    stack: state.user.stack,
    viewing: state.user.viewing,
    contacts: state.contacts.byId,
    loans: state.loans.byId
} );
  
const mapDispatch = ( dispatch ) => ( {
} );
  
export default connect( mapProps, mapDispatch )( SendTxt );